import { render, staticRenderFns } from "./profileNavbar.vue?vue&type=template&id=36599952&scoped=true&"
import script from "./profileNavbar.vue?vue&type=script&lang=js&"
export * from "./profileNavbar.vue?vue&type=script&lang=js&"
import style0 from "./profileNavbar.vue?vue&type=style&index=0&id=36599952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36599952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36599952')) {
      api.createRecord('36599952', component.options)
    } else {
      api.reload('36599952', component.options)
    }
    module.hot.accept("./profileNavbar.vue?vue&type=template&id=36599952&scoped=true&", function () {
      api.rerender('36599952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/profileNavbar.vue"
export default component.exports